/**
 * Canonical token metadata for the swap UI.
 *
 * These are the same token addresses and decimals the Go router carries
 * in its pool registry. We keep them here in TS form because the frontend
 * needs to read wallet balances via wagmi (`useBalance`) before a quote
 * is even issued, and it would be wasteful to roundtrip to the backend
 * just for static metadata.
 */

import type { Address } from "viem";

export type TokenSymbol = "USDC" | "ASIC";

export interface TokenInfo {
  symbol: TokenSymbol;
  name: string;
  address: Address;
  decimals: number;
  /** Single-character or emoji glyph rendered as a tiny pill. Replace
   *  with real SVG icons later if you want to ship something slicker. */
  glyph: string;
  color: string;
}

export const TOKENS: Record<TokenSymbol, TokenInfo> = {
  USDC: {
    symbol: "USDC",
    name: "USD Coin",
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    decimals: 6,
    glyph: "$",
    color: "#2775ca",
  },
  ASIC: {
    symbol: "ASIC",
    name: "Application Specific Internet Coin",
    address: "0x347a96a5BD06D2E15199b032F46fB724d6c73047",
    decimals: 12,
    glyph: "⛏",
    color: "#f59e0b",
  },
};

/** Returns the "other" token in the USDC <-> ASIC pair. */
export function oppositeToken(t: TokenSymbol): TokenSymbol {
  return t === "USDC" ? "ASIC" : "USDC";
}

/** Backend direction string matching the Go `cmdQuote --dir` flag. */
export function directionString(inTok: TokenSymbol): "USDC->ASIC" | "ASIC->USDC" {
  return inTok === "USDC" ? "USDC->ASIC" : "ASIC->USDC";
}
